import React from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import styles from './PopOver.module.scss.js';

function PopOver(_ref) {
  var visible = _ref.visible,
    children = _ref.children,
    className = _ref.className,
    dataTestId = _ref.dataTestId;
  return /*#__PURE__*/React.createElement(CSSTransition, {
    "in": visible,
    timeout: 500,
    mountOnEnter: true,
    unmountOnExit: true,
    classNames: "tooltip"
  }, function (state) {
    var classes = classNames(visible && styles.visible, styles.infoBox, className, styles["tooltip-".concat(state)]);
    return /*#__PURE__*/React.createElement("div", {
      className: classes,
      id: dataTestId
    }, children);
  });
}
PopOver.propTypes = {
  visible: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  dataTestId: PropTypes.string
};
PopOver.defaultProps = {
  visible: false,
  children: null,
  className: '',
  dataTestId: null
};

export { PopOver as default };
